module.exports = __webpack_public_path__ + "f03534160d5f5c3bcfb90ca06002f65a.jpg";